const API_BASE_URL = 'https://sbp.menu-rest.com';
const ID_QR = '36444400';

// FastAPI отдаёт ошибки валидации как detail: [{msg, loc, ...}, ...],
// а не строкой — без этого new Error(detail) превращался в "[object Object]"
// Сообщения по полям, которые вводит посетитель: текст бэкенда содержит техническое имя поля
const FIELD_MESSAGES = {
    client_email: 'Введите корректный email, например name@domain.ru'
};

function extractErrorMessage(detail, fallback) {
    if (!detail) return fallback;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
        const msgs = detail
            .map(item => {
                const field = Array.isArray(item?.loc) ? item.loc[item.loc.length - 1] : null;
                if (FIELD_MESSAGES[field]) return FIELD_MESSAGES[field];
                const msg = item?.msg && item.msg.replace(/^Value error,\s*/, '');
                // валидатор уровня модели может не указать поле в loc, но назвать его в тексте
                const named = msg && Object.keys(FIELD_MESSAGES).find(name => msg.includes(name));
                return named ? FIELD_MESSAGES[named] : msg;
            })
            .filter(Boolean)
            .filter((msg, i, arr) => arr.indexOf(msg) === i);
        if (msgs.length > 0) return msgs.join('; ');
    }
    return fallback;
}

/**
 * @param {string} description
 * @param {{ menu_id: number, position_count: number }[]} items
 * @returns {Promise<{order_id: string, qr_url: string, status: string}>}
 */
export async function createPaymentOrder({
    description,
    items,
    businessLunches = []
}) {
    const body = {
        description,
        id_qr: ID_QR
    };
    if (items.length > 0)
        body.items = items;
    if (businessLunches.length > 0)
        body.business_lunches = businessLunches.map(bl => ({bl_id: bl.bl_id, count: bl.count, choices: bl.choices}));

    const response = await fetch(`${API_BASE_URL}/orders/create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });

    if (!response.ok) {
        const error = await response
            .json()
            .catch(() => ({}));
        throw new Error(extractErrorMessage(error.detail, 'Ошибка создания заказа'));
    }

    return response.json();
}

/**
 * Создаёт платёжный заказ через from-pos: при переходе в PAID бэкенд автоматически
 * проставляет sent/qr_paid в menu_rest (строка rest_table_order с id = pos_order_id).
 * @param {number|string} posOrderId — id заказа в menu_rest (rest_table_order.id)
 * @param {string} description
 * @param {{ menu_id: number, position_count: number }[]} items
 * @param {{ bl_id: number, count: number, choices: object[] }[]} businessLunches
 * @returns {Promise<{order_id: string, qr_url: string, status: string}>}
 */
export async function createPaymentOrderFromPos({
    posOrderId,
    description,
    items,
    businessLunches = [],
    client_email,
    client_phone
}) {
    const body = {
        description,
        id_qr: ID_QR
    };
    if (items.length > 0)
        body.items = items;
    if (businessLunches.length > 0)
        body.business_lunches = businessLunches.map(bl => ({bl_id: bl.bl_id, count: bl.count, choices: bl.choices}));
    if (client_email) body.client_email = client_email;
    if (client_phone) body.client_phone = client_phone;

    const response = await fetch(`${API_BASE_URL}/orders/from-pos/${posOrderId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });

    if (!response.ok) {
        const error = await response
            .json()
            .catch(() => ({}));
        throw new Error(extractErrorMessage(error.detail, 'Ошибка создания заказа'));
    }

    return response.json();
}

/**
 * @param {string} orderId
 * @returns {Promise<{order_id: string, order_number: string, status: string, total_amount: number, paid_at: string|null, created_at: string}>}
 */
export async function getOrderStatus(orderId) {
    const response = await fetch(`${API_BASE_URL}/orders/${orderId}/status`, {method: 'GET'});

    if (!response.ok) {
        const error = await response
            .json()
            .catch(() => ({}));
        throw new Error(extractErrorMessage(error.detail, 'Ошибка получения статуса'));
    }

    return response.json();
}

/**
 * @param {string} orderId
 * @returns {Promise<{order_id: string, order_number: string, status: string, cancelled_at: string}>}
 */
export async function cancelOrder(orderId) {
    const response = await fetch(`${API_BASE_URL}/orders/${orderId}/cancel`, {method: 'POST'});

    if (!response.ok) {
        const error = await response
            .json()
            .catch(() => ({}));
        throw new Error(extractErrorMessage(error.detail, 'Ошибка отмены заказа'));
    }

    return response.json();
}

export {API_BASE_URL, ID_QR};
